import {api} from './api'
import {ApiResponse, User, UserActivity} from '../types'

export const getUsers = async (): Promise<User[]> => {
    try {
        const response = await api.get<ApiResponse<User[]>>('/api/admin/users')
        console.log('📥 getUsers response:', response.data)
        return response.data.data || []
    } catch (error) {
        console.error('Error fetching users:', error)
        return []
    }
}

export const getUserActivity = async (userId: string): Promise<UserActivity | null> => {
    try {
        const response = await api.get<ApiResponse<UserActivity>>(`/api/users/${userId}/activity`)
        return response.data.data || null
    } catch (error) {
        console.error('Error fetching user activity:', error)
        return null
    }
}

export const updateUserBalance = async (userId: string, amount: number): Promise<boolean> => {
    try {
        const response = await api.post('/api/admin/users/balance', {userId, amount})
        return response.data.success
    } catch (error) {
        console.error('Error updating user balance:', error)
        return false
    }
}

export const getUsersByOperator = async (operator: 'alfa' | 'touch'): Promise<User[]> => {
    try {
        const response = await api.get<ApiResponse<User[]>>(`/api/admin/users/operator/${operator}`)
        return response.data.data || []
    } catch (error) {
        console.error('Error fetching users by operator:', error)
        return []
    }
}